import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ec89018"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center gap-2" }
const _hoisted_2 = { class: "name flex-fill" }
const _hoisted_3 = {
  key: 0,
  class: "w-50px text-gray-400 text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.option?.label), 1),
    (_ctx.option?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.option.id), 1))
      : _createCommentVNode("", true)
  ]))
}